var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{attrs:{"cols":_vm.cols}},[_c('v-sheet',{staticClass:"v-label-input px-2 py-2 text-right",attrs:{"rounded":"","outlined":"","color":"lighten-3"}},[_vm._v(" "+_vm._s(_vm._f("toCurrency")(_vm.value))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }